"use client";

import { useState } from "react";
import Image from "next/image";
import { X } from "lucide-react";

import { AppAssets } from "@/lib/assets";

interface AdFloatingBannerProps {
  src?: string;
  href?: string;
}

/** Popup C — floating banner tipis di bawah header, bisa di-close. */
export function AdFloatingBanner({ src = AppAssets.promoBanner, href }: AdFloatingBannerProps) {
  const [open, setOpen] = useState(true);

  if (!open) return null;

  const inner = (
    <div className="relative h-14 w-full">
      <Image
        src={src}
        alt="Iklan sponsor"
        fill
        sizes="512px"
        className="object-cover"
      />
      <div aria-hidden className="absolute inset-0 bg-black/35" />
      <div className="absolute inset-0 flex items-center px-3">
        <span className="flex-1 font-label text-label-caps text-[10px] uppercase tracking-widest text-white/70">
          Sponsor resmi pertandingan ini
        </span>
        <button
          onClick={(e) => { e.preventDefault(); setOpen(false); }}
          aria-label="Tutup iklan"
          className="grid size-6 place-items-center rounded-full bg-black/50 text-white"
        >
          <X className="size-3" aria-hidden />
        </button>
      </div>
    </div>
  );

  return (
    <div className="overflow-hidden rounded-xl">
      {href ? (
        <a href={href} target="_blank" rel="noopener noreferrer" className="block">
          {inner}
        </a>
      ) : (
        inner
      )}
    </div>
  );
}
